import { getBaseURL } from 'helpers'
import React from 'react'
import { useTranslation } from 'react-i18next';

const TextAnalysis = () => {
    const { t } = useTranslation();
    return (
        <div className='container mt-20'>
            <h3 className="mx-auto text-center font-custom-2 fs-b-2 my-4">{t("2982", "Qualitative Analysis Methodology: Text analysis using Natural Language Processing")}</h3>
            {/* This row will show only on small screens like xs, sm */}
            <div className="bg-light-orange mt-8 text-center d-block d-md-none">
                <h1 className='mx-auto text-center font-custom-2 fs-b-2 pt-2'>{t("2983", "Recommendation")}</h1>
                <p className='fs-4 py-2 px-15'>
                    {/* {t("2984", "Undertake a strategic review of future national veterinary needs considering the number of veterinarians, the rate of new graduates/immigration of veterinarians and the rate of retirement/loss to the profession")} */}
                    {t("6230", "Include stakeholder collaboration and consultation in the process of finalizing and implementing the updated veterinary legislation and regulation.")}
                </p>
            </div>
            <div className="row d-flex d-md-none">
                <div className="col-6">
                    <div className="container text-center">
                        <img className='text-center' src={getBaseURL("/assets/icons/down-arrow.png")}
                            style={{
                                width: "30px",
                                height: "50px",
                                marginBottom: "10px"
                            }}
                            alt="" />
                    </div>
                </div>
                <div className="col-1 mb-2">
                </div>
                <div className="col-5">
                    <div className="container text-center">
                        <img className='text-center' src={getBaseURL("/assets/icons/down-arrow.png")}
                            style={{
                                width: "30px",
                                height: "50px",
                                marginBottom: "10px"
                            }}
                            alt="" />
                    </div>
                </div>
            </div>
            <div className="px-3 row d-flex d-md-none">
                <div className="col-6 bg-pink pt-4 shadow mb-2">
                    <h2>
                        {t("2997", "Key Recommendation:")}
                    </h2>
                    <p>
                        {t("6231", "Collaborate with stakeholders.")}
                    </p>
                </div>
                <div className="col-1 mb-2 text-center d-flex">
                </div>
                <div className="col-5 bg-pink p-4 shadow mb-2">
                    <h2>
                        {/* {t("2990", "Tags:")} */}
                        Tags:
                    </h2>
                    <ul>
                        <li>
                            {t("6232", "Privator")}
                        </li>
                        <li>
                            {t("6233", "Sector")}
                        </li>
                        <li>
                            {t("6234", "Support")}
                        </li>
                        <li>
                            {t("6235", "Government")}
                        </li>
                        <li>
                            {t("6236", "Activities")}
                        </li>
                        <li>
                            {t("6237", "Antimicrobial")}
                        </li>
                        <li>
                            {t("6238", "Sensitivity")}
                        </li>
                        <li>
                            {t("6239", "Testing")}
                        </li>
                        <li>
                            {t("6240", "Vaccination")}
                        </li>
                        <li>
                            {t("6241", "Poultry")}
                        </li>
                    </ul>

                </div>
            </div>
            <div className="row d-flex d-md-none">
                <div className="col-6">
                    <div className="container text-center">
                        <img className='text-center' src={getBaseURL("/assets/icons/down-arrow.png")}
                            style={{
                                width: "30px",
                                height: "50px",
                                marginBottom: "10px"
                            }}
                            alt="" />
                    </div>
                </div>
            </div>
            <div className="row mb-10 d-flex d-md-none">
                <div className="col-7">
                    <div className="p-4 bg-beige shadow">
                        <h2>
                            {t("6229", "Umbrella Recommendation")}:
                        </h2>
                        <p>
                            {t("6242", "Engage and collaborate with stakeholders.")}
                            {/* {t("2998", "Veterinary services need Evaluation")} */}
                        </p>
                    </div>
                </div>
                <div className="col-md-4"></div>
            </div>
            {/* This section will show only on larger screens like md and above */}
            <div className="row d-none d-md-flex">
                <div className="col-md-2">
                    <h1 className='mx-auto font-custom-2 fs-b-2 pt-2'>Tags:</h1>
                </div>
                <div className="col-md-2 bg-white mt-3 p-2 m-2 centered-list border">
                    <ul className="">
                        <li >
                            {t("6243", "Stakeholders")}
                        </li>
                        <li>
                            {t("6244", "Draft")}
                        </li>
                        <li>
                            {t("6245", "International")}
                        </li>
                        <li>
                            {t("6246", "Standards")}
                        </li>
                    </ul>
                </div>
                <div className="col-md-2 bg-whtie centered-list border mt-3 p-2 m-2">
                    <ul>
                        <li>
                            {t("6247", "Engagement")}
                        </li>
                        <li>
                            {t("6243", "Stakeholders")}
                        </li>
                        <li>
                            {t("6248", "Legislation")}
                        </li>
                        <li>
                            {t("6249", "Preparation")}
                        </li>
                    </ul>
                </div>
                <div className="col-md-2 bg-white centered-list border mt-3 p-2 m-2">
                    <ul>
                        <li>
                            {t("6250", "Industry")}
                        </li>
                        <li>
                            {t("6251", "Groups")}
                        </li>
                        <li>
                            {t("203", "Contact")}
                        </li>
                        <li>
                            {t("6252", "Communication")}
                        </li>
                        <li>
                            {t("6253", "Livestock")}
                        </li>
                        <li>
                            {t("6254", "Producers")}
                        </li>
                    </ul>
                </div>
                <div className="col-md-2 bg-white centered-list border mt-3 p-2 m-2">
                    <ul>
                        <li>
                            {t("6243", "Stakeholders")}
                        </li>
                        <li>
                            {t("6255", "Collaboration")}
                        </li>
                        <li>
                            {t("6256", "Consultation")}
                        </li>
                        <li>
                            {t("6257", "Veterinary")}
                        </li>
                        <li>
                            {t("6248", "Legislation")}
                        </li>
                        <li>
                            {t("6258", "Regulation")}
                        </li>
                        <li>
                            {t("6259", "Process")}
                        </li>
                        <li>
                            {t("6260", "Finalizing")}
                        </li>
                        <li>
                            {t("6261", "Implementing")}
                        </li>
                    </ul>
                </div>
            </div>
            <div className="row d-none d-md-flex">
                <div className="col-md-2 text-center m-2">
                </div><div className="col-md-2 text-center m-2">
                    <img className='text-center' src={getBaseURL("/assets/icons/down-arrow.png")}
                        style={{
                            width: "20px",
                            height: "50px",
                            marginBottom: "10px",
                            transform: "rotate(180deg)"
                        }}
                        alt="" />
                </div><div className="col-md-2 text-center m-2">
                    <img className='text-center' src={getBaseURL("/assets/icons/down-arrow.png")}
                        style={{
                            width: "20px",
                            height: "50px",
                            marginBottom: "10px",
                            transform: "rotate(180deg)"
                        }}
                        alt="" />
                </div><div className="col-md-2 text-center m-2">
                    <img className='text-center' src={getBaseURL("/assets/icons/down-arrow.png")}
                        style={{
                            width: "20px",
                            height: "50px",
                            marginBottom: "10px",
                            transform: "rotate(180deg)"
                        }}
                        alt="" />
                </div><div className="col-md-2 text-center m-2">
                    <img className='text-center' src={getBaseURL("/assets/icons/down-arrow.png")}
                        style={{
                            width: "20px",
                            height: "50px",
                            marginBottom: "10px",
                            transform: "rotate(180deg)"
                        }}
                        alt="" />
                </div>
                {/* <div className="col-md-2 mt-3 text-center m-2">
                    <img className='text-center' src={getBaseURL("/assets/icons/down-arrow.png")}
                            style={{
                                width: "20px",
                                height: "50px",
                                marginBottom: "10px"
                            }}
                            alt="" />
                </div> */}
            </div>
            <div className="row d-none d-md-flex">
                <div className="col-md-2">
                    <h1 className='mx-auto font-custom-2 fs-b-2 pt-2'>{t("2983", "Recommendation")}:</h1>
                </div>
                <div className="col-md-2 bg-light-orange text-center m-2">
                    <p className='fs-4 p-1'>
                        {t("6262", "Engage stakeholders as appropriate on drafts international standard.")}
                    </p>
                </div>
                <div className="col-md-2 bg-light-orange text-center m-2">
                    <p className='fs-4 p-1'>
                        {t("6263", "Director of Veterinary Services is encouraged to engage with all key stakeholders especially when legislation that affects such stakeholders is being prepared.")}
                    </p>
                </div>
                <div className="col-md-2 bg-light-orange text-center m-2">
                    <p className='fs-4 p-1'>
                        {t("6264", "Engage with industry groups as they develop to better facilitate contact and communication with livestock producers.")}
                    </p>
                </div>
                <div className="col-md-2 bg-light-orange text-center m-2">
                    <p className='fs-4 p-1'>
                        {t("6265", "Include stakeholder collaboration and consultation in the process of finalizing and implementing the updated veterinary legislation and regulation.")}
                    </p>
                </div>
                {/* <div className="col-md-2 bg-light-orange text-center m-2">
                    <p className='fs-4 p-1'>
                        {t("-1", "Work with the private sector to increase support for the government by providing additional activities such as antimicrobial sensitivity testing and vaccinaion or poultry")}
                    </p>
                </div> */}
            </div>
            <div className="row d-none d-md-flex">
                <div className="col-md-2 text-center m-2">

                </div>
                <div className="col-md-2 text-center m-2">
                    <img className='text-center' src={getBaseURL("/assets/icons/down-arrow.png")}
                        style={{
                            width: "20px",
                            height: "50px",
                            marginBottom: "10px"
                        }}
                        alt="" />
                </div><div className="col-md-2 text-center m-2">
                    <img className='text-center' src={getBaseURL("/assets/icons/down-arrow.png")}
                        style={{
                            width: "20px",
                            height: "50px",
                            marginBottom: "10px"
                        }}
                        alt="" />
                </div><div className="col-md-2 text-center m-2">
                    <img className='text-center' src={getBaseURL("/assets/icons/down-arrow.png")}
                        style={{
                            width: "20px",
                            height: "50px",
                            marginBottom: "10px"
                        }}
                        alt="" />
                </div><div className="col-md-2 text-center m-2">
                    <img className='text-center' src={getBaseURL("/assets/icons/down-arrow.png")}
                        style={{
                            width: "20px",
                            height: "50px",
                            marginBottom: "10px"
                        }}
                        alt="" />
                </div>
                {/* <div className="col-md-2 mt-3 text-center m-2">
                    <img className='text-center' src={getBaseURL("/assets/icons/down-arrow.png")}
                            style={{
                                width: "20px",
                                height: "50px",
                                marginBottom: "10px"
                            }}
                            alt="" />
                </div> */}
            </div>
            <div className="row d-none d-md-flex">
                <div className="col-md-2">
                    <h1 className=' font-custom-2 fs-b-2 pt-2'> {t("2997", "Key Recommendation:")}</h1>
                </div>
                <div className="col-md-4 bg-lightest-orange text-center m-2">
                    <p className='fs-4 p-1'>
                        {t("6266", "Engage Stakeholders.")}
                    </p>
                </div>
                <div className="col-md-2 bg-lightest-orange text-center m-2">
                    <p className='fs-4 p-1'>
                        {t("6267", "Engage with industry.")}
                    </p>
                </div>
                <div className="col-md-2 bg-lightest-orange text-center m-2">
                    <p className='fs-4 p-1'>
                        {t("6231", "Collaborate with stakeholders.")}
                    </p>
                </div>
                {/* <div className="col-md-2 bg-light-orange text-center m-2">
                    <p className='fs-4 p-1'>
                        {t("-1", "Work with private sector.")}
                    </p>
                </div> */}
            </div>
            <div className="row d-none d-md-flex">
                <div className="col-md-2 text-center m-2">

                </div><div className="col-2 text-center m-2">
                    <img className='text-center' src={getBaseURL("/assets/icons/down-arrow.png")}
                        style={{
                            width: "20px",
                            height: "50px",
                            marginBottom: "10px"
                        }}
                        alt="" />
                </div><div className="col-md-2 text-center m-2">
                    <img className='text-center' src={getBaseURL("/assets/icons/down-arrow.png")}
                        style={{
                            width: "20px",
                            height: "50px",
                            marginBottom: "10px"
                        }}
                        alt="" />
                </div><div className="col-md-2 text-center m-2">
                    <img className='text-center' src={getBaseURL("/assets/icons/down-arrow.png")}
                        style={{
                            width: "20px",
                            height: "50px",
                            marginBottom: "10px"
                        }}
                        alt="" />
                </div><div className="col-md-2 text-center m-2">
                    <img className='text-center' src={getBaseURL("/assets/icons/down-arrow.png")}
                        style={{
                            width: "20px",
                            height: "50px",
                            marginBottom: "10px"
                        }}
                        alt="" />
                </div>
            </div>
            <div className="row d-none d-md-flex">
                <div className="col-md-2">
                    <h1 className=' font-custom-2 fs-b-2 pt-2'> {t("6229", "Umbrella Recommendation")}:</h1>
                </div>
                <div className="col-md-2 bg-dark-orange text-center m-2 mr-0">
                    <p className='fs-4 p-1'>
                        {t("6268", "Engage and educate stakeholders.")}
                    </p>
                </div>
                <div className="col-6 bg-dark-orange text-center m-2">
                    <p className='fs-4 p-1'>
                        {t("6242", "Engage and collaborate with stakeholders.")}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default TextAnalysis
